module.exports = __webpack_public_path__ + "static/stop-record-143c29a4b324683899c121db445c8963.gif";